import React, { useEffect } from "react";
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
// ---------------- icons ------------
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { MicrowaveOutlined } from "@mui/icons-material";
import moduleRoutes from "@routes/moduleRouteList";
import dashboardRouteList from "../../routeList";

const base = (window as any)._env_?.BASE_URL;
function ExtraDetails({ products, sx }: any) {
  const navigateTo = useNavigate();
  const [currentTime, setCurrentTime] = React.useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const seconds = currentTime.getSeconds();

  const formattedTime = `${hours}:${minutes}:${seconds}`;
  return (
    <Card sx={sx}>
      <CardHeader
        title={
          <span style={{ fontSize: "1.1rem" }}>
            Other details <AccessTimeIcon /> {formattedTime}
          </span>
        }
      />
      <List>
        {products?.map((product: any, index: number) => {
          const hasDivider = index < products.length - 1;
          //   const ago = formatDistanceToNow(product.updatedAt);

          return (
            <ListItem divider={hasDivider} key={product.id}>
              <ListItemAvatar>
                <Avatar variant="rounded" sx={{ bgcolor: product.color }}>
                  <product.Icon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={product.name}
                primaryTypographyProps={{ variant: "subtitle1" }}
                secondary={
                  <span>
                    <CalendarMonthIcon />{" "}
                    {new Date().toLocaleString("default", { month: "long" })}
                  </span>
                }
                secondaryTypographyProps={{ variant: "body2" }}
              />
              <Typography>
                {product.inHouse}{" "}
                {product.outHouse && (
                  <span>(out.house {product.outHouse})</span>
                )}
              </Typography>
            </ListItem>
          );
        })}
      </List>
      <Divider />
      <CardActions>
        <div className="grid grid-cols-3 gap-3 pt-2">
          <Card
            sx={{ bgcolor: "primary.main", color: "white", cursor: "pointer" }}
            onClick={() => {
              navigateTo(
                `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.reception}`
              );
            }}
          >
            <CardContent>
              <ListItem disablePadding>
                <ListItemIcon>
                  <AssignmentOutlinedIcon
                    sx={{ fontSize: "2rem", color: "white" }}
                  />
                </ListItemIcon>
                <ListItemText>
                  <span className="text-[.8rem]">RECEPTION</span>
                </ListItemText>
              </ListItem>
            </CardContent>
          </Card>
          <Card
            sx={{ bgcolor: "success.main", color: "white", cursor: "pointer" }}
            onClick={() => {
              navigateTo(
                `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.lab}`
              );
            }}
          >
            <CardContent>
              <ListItem disablePadding>
                <ListItemIcon>
                  <BiotechOutlinedIcon
                    sx={{ fontSize: "2rem", color: "white" }}
                  />
                </ListItemIcon>
                <ListItemText>
                  <span className="text-[.8rem]">LAB</span>
                </ListItemText>
              </ListItem>
            </CardContent>
          </Card>
          <Card
            sx={{ bgcolor: "warning.main", color: "white", cursor: "pointer" }}
            onClick={() => {
              navigateTo(
                `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.Radiology}`
              );
            }}
          >
            <CardContent>
              <ListItem disablePadding>
                <ListItemIcon>
                  <MicrowaveOutlined
                    sx={{ fontSize: "2rem", color: "white" }}
                  />
                </ListItemIcon>
                <ListItemText>
                  <span className="text-[.8rem]">Radiology</span>
                </ListItemText>
              </ListItem>
            </CardContent>
          </Card>
        </div>
      </CardActions>
    </Card>
  );
}

export default ExtraDetails;
